// Gallery thumbnail switcher
document.querySelectorAll('.gthumb').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.gthumb').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const main = document.getElementById('galleryMain');
    if (main) main.src = btn.dataset.img;
  });
});

// Allinea l'etichetta ATC alla barra selezionata nel widget di Kaching.
// Il selettore hand-coded non esiste piu': il prezzo dipende dal bundle scelto,
// non da una variante, quindi non puo' arrivare da Liquid.
//
// Regola di sicurezza: il pulsante si blocca SOLO se Kaching ha un'offerta per
// questo prodotto ma non l'ha ancora iniettata (in quella finestra il form
// comprerebbe la variante base a prezzo pieno, senza sconto bundle).
// Se Kaching non ha offerte, il pulsante resta attivo: meglio vendere la
// variante singola che lasciare la pagina senza vendite.
(function syncAtcWithKaching(){
  const atc = document.querySelector('.atc');
  const form = document.getElementById('treudas-form');
  if (!atc || !form) return;

  const BASE = '⚡ ORDINA ORA';
  const SUB = '<span class="atc-sub">Spedizione gratuita in 5-7 giorni</span>';

  const kachingHaOfferta = () => window.kachingBundlesEnabled === true;
  const kachingPronto = () =>
    !!form.querySelector('input[name^="properties[__kaching_bundles]"]');

  // Il prezzo si legge dall'elemento dedicato di Kaching, non dal testo della
  // card: li' dentro ci sono anche il barrato (.bar-full-price) e il badge
  // "Risparmia 68€", che leggendo il testo grezzo finivano sul pulsante.
  function barraSelezionata(){
    const checked = document.querySelector('input[name^="kaching-bundles-deal"]:checked');
    const dalRadio = checked && checked.closest('.kaching-bundles__bar');
    return dalRadio || document.querySelector('.kaching-bundles__bar--selected');
  }

  function prezzoSelezionato(){
    const bar = barraSelezionata();
    if (!bar) return null;
    const el = bar.querySelector('.kaching-bundles__bar-price');
    const t = el ? el.textContent.trim() : '';
    return /\d/.test(t) ? t : null;   // senza cifre non e' un prezzo: meglio niente
  }

  let lastLabel = null, lastDisabled = null;
  function update(){
    let offerta = false, pronto = false, prezzo = null;
    try {
      offerta = kachingHaOfferta();
      pronto = kachingPronto();
      if (pronto) prezzo = prezzoSelezionato();
    } catch (e) { /* fallback sotto */ }

    // blocco solo nella finestra "offerta esiste ma non ancora iniettata":
    // li' il form comprerebbe la variante base senza sconto bundle
    const disabled = offerta && !pronto;
    const label = (prezzo ? `${BASE} — ${prezzo}` : BASE) + SUB;

    if (label !== lastLabel) { atc.innerHTML = label; lastLabel = label; }
    if (disabled !== lastDisabled) { atc.disabled = disabled; lastDisabled = disabled; }
  }

  update();
  document.addEventListener('change', update);
  // Solo childList e solo sul buy box: intercetta l'iniezione del widget senza
  // osservare l'intera pagina (attributes:true su body costerebbe troppo).
  const zona = form.closest('.buybox') || form.parentElement || document.body;
  new MutationObserver(update).observe(zona, { subtree: true, childList: true });
  // Kaching imposta "checked" come proprieta' JS: non genera mutation record,
  // quindi serve un poll breve per intercettare la preselezione.
  let ticks = 0;
  const poll = setInterval(() => { update(); if (++ticks > 60) clearInterval(poll); }, 250);
})();

// Niente accumulo: il carrello si azzera a ogni caricamento, cosi' ogni ORDINA
// parte da zero e produce un carrello con il solo bundle scelto.
//
// NON si intercetta il submit: il bundle lo costruisce Kaching, che inietta le
// sue properties nel form e gestisce il click per conto suo. Il vecchio handler
// qui svuotava il carrello e poi aggiungeva a mano una singola variante via
// cart/add.js, buttando via il bundle appena scelto.
//
// Sicuro perche' il funnel vende un solo prodotto: non esiste un carrello
// "costruito altrove" da preservare.
(function clearCartOnLoad(){
  const svuota = () => fetch('/cart/clear.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  }).catch(() => {});

  svuota();

  // Tornando indietro dal carrello o dal checkout il browser ripristina la
  // pagina dalla bfcache SENZA rieseguire gli script: lo svuotamento qui sopra
  // non ripartirebbe e il click successivo sommerebbe al bundle precedente.
  // pageshow con persisted=true e' l'unico evento che intercetta quel ritorno.
  window.addEventListener('pageshow', (e) => { if (e.persisted) svuota(); });
})();

// Delivery date estimate (5-7 working days)
(function setDeliveryDay(){
  const el = document.getElementById('delivery-day');
  if (!el) return;
  const months = ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic'];
  const start = new Date();
  start.setDate(start.getDate() + 5);
  const end = new Date();
  end.setDate(end.getDate() + 7);
  const fmt = d => `${d.getDate()} ${months[d.getMonth()]}`;
  el.textContent = `${fmt(start)}-${fmt(end)}`;
})();

// Urgency clock (mirror of countdown)
(function syncUrgencyClock(){
  setInterval(() => {
    const main = document.getElementById('countdown');
    const urg = document.getElementById('urgency-clock');
    if (main && urg) urg.textContent = main.textContent;
  }, 1000);
})();
